import { AggregateType, DateRangeType, DurationUnit, TimeframeType } from "../../common/enums/DRCXEnums";
import { NumericalFunctionEnum } from "../../common/enums/NumericalFunctionEnum";
import { RecipientSubTypeEnum } from "../../common/enums/RecipientSubTypeEnum";
import { RecipientTypeEnum } from "../../common/enums/RecipientTypeEnum";
import { RulesEngineActionTypeEnum } from "../../common/enums/RulesEngineActionTypeEnum";
import { RulesEngineCompilationDiagnosticSeverityEnum } from "../../common/enums/RulesEngineCompilationDiagnosticSeverityEnum";
import { RulesEngineRuleCustomerTypeEnum } from "../../common/enums/RulesEngineRuleCustomerTypeEnum";
import { RulesEngineRuleFactTypeEnum } from "../../common/enums/RulesEngineRuleFactTypeEnum";
import { RulesEngineRuleRunTypeEnum } from "../../common/enums/RulesEngineRuleRunTypeEnum";
import { RulesEngineRuleScopeEnum } from "../../common/enums/RulesEngineRuleScopeEnum";
import { RulesEngineSimulationStatusEnum } from "../../common/enums/RulesEngineSimulationStatusEnum";
import { RulesEngineRuleTypeEnum } from "../../common/enums/RulesEngineTypeEnum";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IPageableResults } from "../../common/models/IPageableResults";
import { IPaginatedRequest } from "../../common/models/PaginatedRequest";
import { IDRCXConfigurationSectionColumnDTO } from "../../common/models/drcx/DRCXConfigurationSectionColumnDTO";
import { IDRCXConfigurationSectionObjectDTO } from "../../common/models/drcx/DRCXConfigurationSectionObjectDTO";
import { IDRCXConfigurationTimeframeDTO } from "../../common/models/drcx/DRCXConfigurationTimeframeDTO";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { ITrendingDisplayOptions } from "../trending-data-service/Models";

export enum ExpressionTypeEnum {
    Undefined = 0,
    NumericTagData = 1,
    TextTagData = 2
}

export interface IGetRulesEngineRulesQueryParams {
    ruleID?: number;
    ruleType?: RulesEngineRuleTypeEnum;
    runType?: RulesEngineRuleRunTypeEnum;
    customerType?: RulesEngineRuleCustomerTypeEnum;
}

export interface IRulesEngineRuleModel {
    id: number;
    ruleType: RulesEngineRuleTypeEnum;
    //RulesEngineRuleScopeEnum RuleScope { get; }
    ruleName: string;
    template: string;
    //IRulesEngineRuleDataDefinition RuleDataDefinition { get; }
    //string CreatedBy { get; }
    //DateTimeOffset CreatedTimestamp { get; }
    //string ModifiedBy { get; }
    //DateTimeOffset ? ModifiedTimestamp { get; }
    ruleRunType: RulesEngineRuleRunTypeEnum;
    description: string;
    logicText: string;
    ruleCustomerType: RulesEngineRuleCustomerTypeEnum;

    ruleDataDefinition: IRulesEngineRuleDataDefinitionModel;

    usageCount: number;

    // TODO: Don't think I need these    
    // For UI
    // visible?: boolean;
    // selected?: boolean;
}

export interface IRulesEngineRuleDataDefinitionModel {
    facts: Array<{ name: string, value: number; }>;
}

// TODO: Deserialization of abbreviated properties isn't working properly
// for some reason due to the package's usage of JsonProperty. If I add
// JsonPropertyName attributes, it works fine, but that breaks WebAPI.
// So just use the full property names.
export interface IObjectConfigFilterItem {

    //int ? ID { get; set; }
    id: number;
    //int ? ObjectTypeID { get; set; }
    //otid: number;
    objectTypeID: number;
    //int ? TargetObjectTypeID { get; set; }
    //totid: number;
    targetObjectTypeID: number;
}

export interface IRulesEngineRuleInstanceQueryParams {

    ruleID?: number;
    ruleInstanceID?: number;
    ruleType?: RulesEngineRuleTypeEnum;
    includeDisabled?: boolean;
    ruleRunType?: RulesEngineRuleRunTypeEnum;
    ruleInstancesOnly?: boolean;
    rulesInstanceObjectConfigFilter?: Array<IObjectConfigFilterItem>;
}

export interface IRulesEngineRuleInstanceQueryModel {
    paginatedRequest?: IPaginatedRequest;
    rulesEngineRuleInstanceQueryParams?: IRulesEngineRuleInstanceQueryParams;
    targetObject?: IeLynxObject;
    addGroupObjectsToFilter?: boolean;

    searchParameters?: IRulesEngineRuleInstanceSearchParamsModel;

}

export interface IRulesEngineRuleInstanceSearchParamsModel {
    text: string;
    objectType: eLynxObjectTypeEnum;
}

export interface IRulesEngineRuleInstanceSummaryModel {
    isElynxAdmin: boolean;
    hasDevices: boolean;
    results: IPageableResults<IRulesEngineRuleInstanceModel>;
}

export interface IRulesEngineRuleInstanceModel {
    id: number;
    name: string;
    active: boolean;
    rulesEngineRuleID: number;

    rulesEngineRule: IRulesEngineRuleModel;

    //public List <DRCXConfigurationSectionObject> ObjectConfiguration { get; set; }

    //// facts to override, if any, for this instance of the rule
    //public string FactOverrideJson { get; set; }

    //public IRulesEngineRuleDataDefinition MergedRuleDataDefinition { get; set; }

    //public TimeSpan TumblingWindow { get; set; } = TimeSpan.FromMinutes(15);

    usageCount: number;

    // UI Only
    // isUsageExpanded: boolean;
    // usageRetrievalState: RetrievalState;
    // deviceObjects: Array<IeLynxObject>;
    // deviceObjectCount: number;
    // isDeviceUsageExpanded: boolean;
    // wellObjects: Array<IeLynxObject>;
    // wellObjectCount: number;
    // isWellUsageExpanded: boolean;
    // visible?: boolean;
}

export interface IRulesEngineRuleInstanceUsageModel {
    id: number;
    objectType: eLynxObjectTypeEnum;
    objectName: string;
    visible: boolean;
    hasSchedule: boolean;
    isDisabled: boolean;
    disabledUntil: string;
}

export interface IRulesEngineRuleUsageModel {
    id: number;
    name: string;
}



//////////////////////////////////////////////////////////////////////////////////////////////////////

// #region Edit DTOs

export interface IEditRuleDTO {
    id?: number;
    ruleType?: RulesEngineRuleTypeEnum;
    ruleScope?: RulesEngineRuleScopeEnum;
    ruleName?: string;
    template?: string;
    ruleDataDefinition?: IRuleDataDefinitionDTO;
    createdBy?: string;
    createdTimestamp?: string | Date;
    modifiedBy?: string;
    modifiedTimestamp?: string | Date;
    ruleRunType?: RulesEngineRuleRunTypeEnum;
    description?: string;
    logicText?: string;
    eventStartRuleLogic?: string;
    eventEndRuleLogic?: string;
}

export interface IEditRuleInstanceDTO {
    id?: number;
    name?: string;
    active?: boolean;
    objectConfiguration?: Array<IDRCXConfigurationSectionObjectDTO>;
    mergedRuleDataDefinition?: IRuleDataDefinitionDTO;
    tumblingWindow?: string;
    actions?: Array<IEditActionInstanceDTO>;
    schedules?: Array<IEditRuleScheduleDTO>;

    // ReadOnly Rule Properties
    ruleID?: number;
    ruleName?: string;
    ruleDescription?: string;
    ruleLogicText?: string;
    ruleType?: RulesEngineRuleTypeEnum;
    ruleScope?: RulesEngineRuleScopeEnum;
    ruleRunType?: RulesEngineRuleRunTypeEnum;
    ruleTemplate?: string;
    ruleDataDefinition?: IRuleDataDefinitionDTO;
}

export interface IEditActionInstanceDTO {
    id?: number;
    actionType?: RulesEngineActionTypeEnum;
    outputObjectConfiguration?: Array<IDRCXConfigurationSectionColumnDTO>;
    actionConfiguration?: IActionConfigurationDTO;

    // RulesEngineActionInstanceNotification, RulesEngineActionInstanceReport
    recipients?: Array<INotificationRecipientDTO>;

    // RulesEngineActionInstanceNotification
    notificationLists?: Array<INotificationListDTO>;
    alarmScheme?: IAlarmSchemeDTO;
}

export interface IEditRuleScheduleDTO {
    id?: number;
    description?: string;
    ruleInstanceID?: number;
    startTime?: string | Date;
    endTime?: string | Date;
    dateRangeType?: DateRangeType;
    repeatInterval?: number;
    nextScheduledTime?: string | Date;
    active?: boolean;
    timezone?: string;
}

export interface IRuleDataDefinitionDTO {
    facts?: Array<IRuleFactDTO>;
    canEvaluateWithoutData?: boolean;
}

export interface IRuleFactDTO {
    factType?: RulesEngineRuleFactTypeEnum;
    entityType?: string;

    // RulesEngineRuleFact
    name?: string;
    title?: string;
    replaceable?: boolean;

    // RulesEngineValueFact
    groupingTimeframe?: TimeframeType;
    groupingFunction?: NumericalFunctionEnum;
    aggregationType?: AggregateType;
    aggregationPeriod?: number;
    aggregationFunction?: NumericalFunctionEnum;
    aggregationStepDateRange?: DateRangeType;
    aggregationStep?: number;
    timeframe?: IDRCXConfigurationTimeframeDTO;
    objectType?: eLynxObjectTypeEnum;

    // RulesEngineTATValueFact
    tatID?: number;

    // RulesEngineTATTypeValueFact
    tatTypeID?: number;

    // RulesEngineRuleConstFact
    value?: number | boolean;

    // RulesEngineRuleExecutionInstanceFact
    ruleInstanceID?: number;
    startOffset?: string;
    endOffset?: string;

    // Shared
    maxCount?: number;
}

export interface INotificationRecipientDTO {
    id?: number;
    to?: string;
    recipientType?: RecipientTypeEnum;
    recipientSubType?: RecipientSubTypeEnum;
}

export interface INotificationListDTO {
    id?: number;
    name?: string;
}

export interface IAlarmSchemeDTO {
    id?: number;
    name?: string;
}

export interface IActionConfigurationDTO {
    // RulesEngineActionConfiguration
    name?: string;
    title?: string;
    version?: string;

    // RulesEngineActionConfigurationNotification
    notificationTemplates?: Array<INotificationTemplateDTO>;
    // Only present in default configuration
    templateItems?: Array<ITemplateItemDTO>;

    // RulesEngineActionConfigurationReport
    attachStartTrend?: boolean;
    attachStartSpreadsheet?: boolean;
    attachEndTrend?: boolean;
    attachEndSpreadsheet?: boolean;
}

export interface INotificationTemplateDTO {
    clearMessage?: string;
    clearSubject?: string;
    eventMessage?: string;
    eventSubject?: string;
    recipientType?: RecipientTypeEnum;
}

export interface ITemplateItemDTO {
    name: string;
    template: string;
}

export interface IDisableScheduleDTO {
    startTime: string;
    endTime: string;
    duration: number;
    durationUnit: DurationUnit;
    timezone: string;
    olsonTimezone: string;
    useDuration: boolean;
}

export interface IAvailableActionDTO {
    ruleType: RulesEngineRuleTypeEnum;
    actionType: RulesEngineActionTypeEnum;
    actionName: string;
    defaultConfiguration: IActionConfigurationDTO;
}

export interface IConditionKeyDTO {
    equatableKey: string;
    label: string;
    expressionType: ExpressionTypeEnum;
}

export interface IRulesEngineCompilationDiagnosticDTO {
    severity: RulesEngineCompilationDiagnosticSeverityEnum;
    message: string;
}

// #endregion Edit DTOs

export interface IRulesEngineSimulatedDataRequestModel {
    displayOptions?: ITrendingDisplayOptions;
    endTime?: Date;
    startTime?: Date;
    windowHeight?: number;
    windowWidth?: number;
    ruleInstance?: IEditRuleInstanceDTO;
    // //ruleDataDefinition?: RuleDataDefinitionModel;
    simulationSessionID?: string;
    notificationID?: string;
}

export interface SimulateRuleQueryParams {
    targetObject: IeLynxObject;
    dataRequestOptions: IRulesEngineSimulatedDataRequestModel;
}

// export interface SimulationDataQueryParams
// {
//     targetObject: IeLynxObject;
//     dataRequestOptions: ITrendingDataRequestModel;
// }

export interface IRulesEngineSimulationInfo {
    isElynxAdmin?: boolean;
    maxSimulationDays?: number;
    maxSimulationRange?: string;
    executionWarningLimit?: number;
}

export interface IRulesEngineSimulationSession {
    id: string;
    startTime: string;
    endTime: string;
    targetObject: IeLynxObject;
}

export interface IRulesEngineAvailableRulesInfoModel {
    //types: Array<IRulesEngineRuleTypeModel>;
    rules: Array<IRulesEngineRuleModel>;
}

export interface IRulesEngineSimulationMessage {
    notificationID: string;
    status: RulesEngineSimulationStatusEnum;
    statusMessage: string;
    percentComplete?: number;
    simulationSessionID: string;
    objectID?: number;
    objectTypeID?: eLynxObjectTypeEnum;
    objectIterations?: number;
    objectIteration?: number;
    sessionIterations?: number;
    sessionIteration?: number;
}

export interface IAvailableNotificationListDTO {
    dt: string;
    id: number;
    oid: number;
}

export interface IAvailableAlarmSchemeDTO {
    dt: string;
    id: number;
    oid: number;
    // TODO: Tier properties
}

export interface IAvailableRecipientDTO {
    dt: string;
    id: number;
    oid: number;
    tid: number;
    uid: number;
}

export interface IAvailableNotificationMessageDTO {
    dt: string;
    id: number;
    tt: string;
}

export interface IAvailableOrganizationDTO {
    dt: string;
    id: number;
}

export interface IAvailableUserDTO {
    dt: string;
    id: number;
    ud: boolean;
}

export interface IAvailableMessageTemplateDTO {
    at: number;
    rt: number;
    rct: number;
    es: string;
    em: string;
    cs: string;
    cm: string;
}

export interface IAvailableTemplateItemDTO {
    at: number;
    rt: number;
    dt: string;
    tp: string;
}

export interface IAvailableNotificationInfoDTO {
    notificationLists: Array<IAvailableNotificationListDTO>;
    alarmSchemes: Array<IAvailableAlarmSchemeDTO>;
    recipients: Array<IAvailableRecipientDTO>;
    messages: Array<IAvailableNotificationMessageDTO>;
    organizations: Array<IAvailableOrganizationDTO>;
    users: Array<IAvailableUserDTO>;
    defaultMessageTemplates: Array<IAvailableMessageTemplateDTO>;
    messageTemplateItems: Array<IAvailableTemplateItemDTO>;
}